module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0116.jpg?v=bf9afb52";